<template>
  <GenericDrawer
    colorKey="bgDrawerContent"
    :isSubDrawer="true"
    :isOpen="true"
    :topLinks="topLinks"
  >
    <template v-slot:prepend>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Administration</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </GenericDrawer>
</template>

<script>
import { ADMINISTRATION_DRAWER_TOP } from "@/utils/links"

export default {
  name: "AdministrationDrawer",
  components: {
    GenericDrawer: () => import("@/components/layouts/core/GenericDrawer.vue")
  },
  data: () => ({
    topLinks: ADMINISTRATION_DRAWER_TOP
  })
}
</script>
